import * as React from "react";

import { useDesktopStyles } from "./useDesktopStyles";

import { TabIndicator } from "../tab";

export interface DesktopPageSectionProps {
    id: string;
    label: string;
    children: React.ReactNode;
    count?: number;
    tabIndicator?: TabIndicator;
}

export const DesktopPageSection = (props: DesktopPageSectionProps) => {
    const { children, id } = props;
    const classes = useDesktopStyles(props);
    return (
        <div className={classes.pageSection} id={`DesktopPageSection-${id}`}>
            {children}
        </div>
    );
};
